import { gql } from '@parkchirp/api-client';

export const GET_DRAFT_INVOICE = gql`
query getDraftInvoice(
  $invoiceId: String!
) {
  getDraftInvoice(
    invoiceId: $invoiceId
  ) {
    id,
    type,
    parkingPeriodMonth,
    parkingPeriodYear,
    readableId,
    dueOn,
    createdAt,
    notes,
    detailNotes,
    amount,
    balance,
    mailInvoice,
    billingDate,
    createdByDailyReport,
    invoiceAttachments {
      name
      type
      data
    }
    subscription {
      id
      accountId
      billingProfileId
      subscriptionName
      taxExempt
      payor {
        infoName
        infoStreet
        infoCity
        infoState
        infoZip
      }
      billingProfile {
        facility {
          id
          facilityName
          facilityNumber
        }
      }
    }
    invoiceLineItems {
      id
      serviceDateStart
      serviceDateEnd
      feeQuantity
      dailyReportId
      lineItemEntries {
        id
        amount
        amountTax1
        amountTax2
        amountTax3
        amountTax4
        transactions {
          id
        }
      }
      fee {
        price
        tax1
        tax2
        tax3
        tax4
        quantity
      }
      rate {
        id
        name
      }
      parker {
        id
        first_name
        last_name
      }
      feeHistory {
        id
        price
        tax1
        feeId
        tax2
        tax3
        tax4
        inputType
        inactiveDate
        taxCalculation
        productCode {
          id
          name
          code
        }
        rateCode {
          id
          name
          code
        }
        fee {
          feeName
          calculationType
          rateFees {
            rateId
          }
          feeType {
            name
            id
          }
        }
        taxTableTax1 {
          taxTableRates {
            percentageOfNet
          }
        }
        taxTableTax2 {
          taxTableRates {
            percentageOfNet
          }
        }
        taxTableTax3 {
          taxTableRates {
            percentageOfNet
          }
        }
        taxTableTax4 {
          taxTableRates {
            percentageOfNet
          }
        }
      }
    }
  }
}
`;

export const GET_SUBSCRIPTION_WITH_ORG_ID_V2 = gql`
  query getSubscriptionById(
    $subscriptionId: String!
  ) {
    getSubscriptionById(
      subscriptionId: $subscriptionId
    ) {
      mailInvoices
      billingProfile {
        facilityId
        facility {
          organizationId
        }
      }
    }
  }
`;

export const GET_TAX_EXEMPT_CERTIFICATES = gql`
  query listTaxExemptCertificates(
    $filters: [Filter]
    $order: Order
    $limit: Int
    $offset: Int
    $special: Special
  ) {
    listTaxExemptCertificates(
      filters: $filters
      order: $order
      limit: $limit
      offset: $offset
      special: $special
    ) {
      total
      offset
      taxExemptCertificates {
        id
        companyName
        issueDate
        issueState
        filePath
        expirationDate
        exemptionNumber
        organizationType
        createdAt
        subscription {
          id
          account_id
          account_balance
          subscription_name
          tax_exempt
          status
          billing_profile {
            id
            name
            facility_id
            facility {
              facility_number
              facility_name
              timezone
            }
          }
          payor {
            readable_id
          }
        }
      }
    }
  }
`;

export const GET_CONTRACTS = gql`
  query listContracts(
    $filters: [Filter]
    $order: Order
    $limit: Int
    $offset: Int
    $special: Special
    $facilityId: String!
  ) {
    listContracts(
      filters: $filters
      order: $order
      limit: $limit
      offset: $offset
      special: $special
      facilityId: $facilityId
    ) {
      total
      offset
      contracts {
        id
        contractType
        documentType
        contractName
        ownerLLC
        startDate
        expirationDate
        filePath
        createdAt
        facility {
          id
          facility_name
          facility_number
          timezone
        }
      }
    }
  }
`;

export const GET_CONTRACT = gql`
  query getContract($keyName: String) {
    getContract(keyName: $keyName)
  }
`;

export const GET_PAYMENT_GROUP_BY_ID = gql`
  query getPaymentGroupById($groupId: Int!) {
    getPaymentGroupById(groupId: $groupId) {
      id
      amount
      paymentType
      paymentMetaId
      notes
      payments {
        paymentId
        transactionDate
        applicationDate
        type
        invoiceNumber
        creditId
        amount
        creditBalance
        canBeReversed
        canBeUnapplied
        canBeRefunded
        creditReadableId
        applicationType
        creditEntryId
        invoiceId
        paymentBatchId
        user {
          email
          firstName
          lastName
        }
      }
      credits {
        paymentId
        transactionDate
        applicationDate
        type
        invoiceNumber
        creditId
        amount
        creditBalance
        canBeReversed
        canBeUnapplied
        applicationType
        creditReadableId
        creditEntryId
        invoiceId
        paymentBatchId
        user {
          email
          firstName
          lastName
        }
      }
    }
  }
`;

export const GET_RECEIPT_V2 = gql`
  query getReceipt($groupId: Int!) {
    getReceipt(groupId: $groupId) {
      pdf
      fileName
    }
  }
`;

export const GET_FACILITIES = gql`
  query listFacilities(
    $limit: Int
    $offset: Int
    $order: facilityOrder
    $filters: [Filter]
    $for_admin_dashboard: Boolean
    $for_facilities_autocomplete: Boolean
    $facility_id: String
    $special: Special
  ) {
    listFacilities(
      limit: $limit
      offset: $offset
      order: $order
      filters: $filters
      for_admin_dashboard: $for_admin_dashboard
      for_facilities_autocomplete: $for_facilities_autocomplete
      facility_id: $facility_id
      special: $special
    ) {
      total
      facilities {
        id
        uid
        facility_name
        city {
          id
          name
        }
        district {
          id
          name
          facilityBranch {
            id
            name
            facilityArea {
              id
              name
            }
          }
        }
        company_number
        facility_number
        timezone
        organization_id
        wordpress_post_id
        organization_id
        organization_settings {
          id
          name
        }
        onlineStartDate
        onlineEndDate
        address
        contract_type
        capacity
        facility_type
        self_park
        valet
        gated_parking_hardware
        valet_parking_technology
        pay_by_phone_technology
        integration
        market
      }
    }
  }
`;

export const GET_INVOICE = gql`
  query getInvoice($readable_id: String) {
    getInvoice(readable_id: $readable_id) {
      id
      subscription {
        billing_profile {
          facility_id
        }
      }
    }
  }
`;

export const GET_CREDITS = gql`
  query listCredits(
    $limit: Int
    $offset: Int
    $filters: [Filter]
    $order: Order
    $facilityId: String
    $special: Special
  ) {
    listCredits(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      facilityId: $facilityId
      special: $special
    ) {
      total
      limit
      offset
      credits {
        id
        readable_id
        balance
        created_at
        amount
        application_type
        subscription {
          subscription_name
          account_id
          payor {
            readable_id
          }
          billing_profile {
            facility_id
            facility {
              facility_number
              facility_name
              timezone
            }
          }
        }
      }
    }
  }
`;

export const LIST_FACILITY_AREAS: any = gql`
  query listFacilityAreas(
    $organizationId: Int!
    $limit: Int
    $offset: Int
    $filters: [Filter]
    $order: Order
    $special: Special
    $includePrimary: Boolean
  ) {
    listFacilityAreas(
      organizationId: $organizationId
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      special: $special,
        includePrimary: $includePrimary
    ) {
      total
      limit
      offset
      facilityAreas {
        id
        name
        code
      }
    }
  }
`;

export const LIST_FACILITY_BRANCHES: any = gql`
  query listFacilityBranches(
    $organizationId: Int!
    $limit: Int
    $offset: Int
    $filters: [Filter]
    $order: Order
    $special: Special
    $includePrimary: Boolean
  ) {
    listFacilityBranches(
      organizationId: $organizationId
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      special: $special,
        includePrimary: $includePrimary
    ) {
      total
      limit
      offset
      facilityBranches {
        id
        name
        code
        areaId
        facilityArea {
          name
          code
        }
      }
    }
  }
`;

export const LIST_FACILITY_DISTRICTS: any = gql`
  query listFacilityDistricts(
    $organizationId: Int!
    $limit: Int
    $offset: Int
    $filters: [Filter]
    $order: Order
    $special: Special
    $includePrimary: Boolean
  ) {
      listFacilityDistricts(
        organizationId: $organizationId,
        limit: $limit,
        offset: $offset,
        filters: $filters,
        order: $order,
        special: $special,
        includePrimary: $includePrimary
        ) {
            total
            limit
            offset
            facilityDistricts {
              id
              name
              code
              branchId
              facilityBranch {
                id
                name
                code
                areaId
                facilityArea {
                  id
                  name
                  code
                  organizationId
                }
            }
          }
        }
  }
`;

export const LIST_GL_CODES = gql`
  query listGLCodes(
    $organizationId: Int!
    $filters: [Filter]
    $order: Order
    $limit: Int
    $offset: Int
    $special: Special
  ) {
    listGLCodes(
      organizationId: $organizationId
      filters: $filters
      order: $order
      limit: $limit
      offset: $offset
      special: $special
    ) {
      total
      offset
      glCodes {
        id
        createdAt
        contractType
        glType
        glCode
        productCode {
          id
          name
          code
          description
          organizationId
          createdAt
          updatedAt
          deletedAt
        }
        facility {
          id
          facility_name
          facility_number
          timezone
        }
        rateCode {
          id
          name
          code
          description
          organizationId
          createdAt
          updatedAt
          deletedAt
        }
      }
    }
  }
`;

export const GET_ORGANIZATION_SETTINGS_BY_ORG_ID: any = gql`
    query getOrganizationSettingsByOrgId(
        $id: Int!
    ) {
        getOrganizationSettingsByOrgId(
            id: $id
        ) {
            requireGLRevProductCode
        }
    }
`;

export const FETCH_PUT_SIGNED_URL: any = gql`
    query depositDocumentsPutUrl(
      $id: String!,
      $basePath: String!,
      $contentType: String!,
  ) {
    depositDocumentsPutUrl(
        id: $id,
        contentType: $contentType,
        basePath: $basePath,
      ) {
        url
      }
  }
`;

export const GET_DEPOSIT_DOCUMENTS: any = gql`
    query getDepositDocuments(
      $paymentBatchId: Int!,
  ) {
    getDepositDocuments(
        paymentBatchId: $paymentBatchId,
      ) {
        id
        createdAt
        description
        path
        paymentBatchId
        contentType
      }
  }
`;

export const GET_DEPOSIT_DOCUMENT_SIGNED_URL: any = gql`
    query getDepositDocumentSignedUrl(
      $path: String!,
  ) {
    getDepositDocumentSignedUrl(
      path: $path,
      ) {
        url
      }
    }
`;

export const LIST_BILLING_PROFILE_NAMES = gql`
    query listBillingProfiles(
        $limit: Int,
        $offset: Int,
        $filters: [Filter],
        $order: Order,
        $isForAdminDashboard: Boolean,
        $facilityId: String
    ) {
        listBillingProfiles(
            limit: $limit,
            offset: $offset,
            filters: $filters,
            order: $order,
            isForAdminDashboard: $isForAdminDashboard,
            facilityId: $facilityId
        ) {
            billing_profiles {
                id
                name
            }
        }
    }
`;

export const LIST_TAX_TABLE_CITIES_BY_ORGANIZATION_ID: any = gql`
    query listTaxTableCitiesByOrganizationId(
        $organization_id: Int!,
    ) {
        listTaxTableCitiesByOrganizationId(organization_id: $organization_id) {
            id,
            name,
            state,
            active,
            timezone,
            organization_id,
            taxes {
                id,
                name,
                active,
                current_tax,
                city_id,
            }
      }
    }
`;

export const LIST_FEES_HISTORY_V2 = gql`
    query listFeesHistoryFromView(
      $feeType: String
      $limit: Int
      $offset: Int
      $order: SortOrder
      $filters: [Filter]
      $groupRows: Boolean
    ) {
      listFeesHistoryFromView(
            feeType: $feeType
            limit: $limit
            offset: $offset
            order: $order
            filters: $filters
            groupRows: $groupRows
        ) {
              total
              data {
                id
                feeId
                feeType
                feeName
                facilityName
                facilityNumber
                facilityTimezone
                taxCalculation
                feeInputType
                tax1
                tax2
                tax3
                tax4
                price
                rateCode
                productCode
                startDate
                taxApplied
                inactiveDate
                feeInactiveDate
                inputType
                taxTableRate1
                status
                taxTableRate2
                taxTableRate3
                net
                gross
                taxTableRate4
                tax1Percentage
                tax2Percentage
                tax3Percentage
                tax4Percentage
                active
                deviceType
                accessDeviceRequired
                calculationType
                recurring
              }
        }
    }
`;

export const LIST_ALL_ACTIVE_FEES_V2 = gql`
    query listAllActiveFees(
      $facilityId: String!
    ) {
      listAllActiveFees(
            facilityId: $facilityId
        ) {
            id
            feeName
            feeAccessDeviceType {
                  accessDeviceTypeId
                  accessDeviceType {
                    type
                  }
            }
            feeTypeId
            feeType {
                name
            }
            feesHistory {
              feeId
              productCode {
                id
                code
              }
              rateCode {
                id
                code
              }
            }
        }
    }
`;

export const LIST_FEES_V2 = gql`
    query listFees(
      $facilityId: String!
    ) {
      listFees(
            facilityId: $facilityId
        ) {
            id
            feeName
            feeAccessDeviceType {
                  accessDeviceTypeId
                  accessDeviceType {
                    type
                  }
            }
            feeTypeId
            feeType {
                name
            }
            feesHistory {
              feeId
              productCode {
                id
                code
              }
              rateCode {
                id
                code
              }
            }
        }
    }
`;

export const LIST_PARKERS_FOR_MANUAL_INVOICES_V2 = gql`
    query listParkersForManualInvoices(
      $subscriptionId: String!
      $parkingPeriodMonth: String!
      $parkingPeriodYear: Int!
    ) {
      listParkersForManualInvoices(
          subscriptionId: $subscriptionId
          parkingPeriodMonth: $parkingPeriodMonth
          parkingPeriodYear: $parkingPeriodYear
        ) {
            id
            firstName
            lastName
            group
            rate {
                id
                name
                rateFees {
                  fee {
                    id
                    feeName
                    calculationType
                    feeTypeId
                    feeType {
                        name
                    }
                    feesHistory {
                      id
                      price
                      tax1
                      tax2
                      tax3
                      tax4
                      inputType
                      taxCalculation
                      productCode {
                        id
                        name
                        code
                      }
                      rateCode {
                        id
                        name
                        code
                        description
                      }
                      taxTableTax1 {
                        taxTableRates {
                          percentageOfNet
                        }
                      }
                      taxTableTax2 {
                        taxTableRates {
                          percentageOfNet
                        }
                      }
                      taxTableTax3 {
                        taxTableRates {
                          percentageOfNet
                        }
                      }
                      taxTableTax4 {
                        taxTableRates {
                          percentageOfNet
                        }
                      }
                    }
                  }
                }
            }
            parkerVehicles {
              license
            }
        }
    }
`;

export const LIST_FEES_FOR_VALIDATION_V2 = gql`
  query listFeesForValidation(
    $facilityId: String!
    $parkingPeriod: String!
  ) {
    listFeesForValidation(
          facilityId: $facilityId
          parkingPeriod: $parkingPeriod
      ) {
        fees {
          id
          feeName
          calculationType
          feeTypeId
          feeType {
            name
          }
          feesHistory {
            id
            price
            tax1
            tax2
            tax3
            tax4
            startDate
            inactiveDate
            inputType
            taxCalculation
            productCode {
              id
              name
              code
            }
            rateCode {
              id
              name
              code
              description
            }
            taxTableTax1 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax2 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax3 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax4 {
              taxTableRates {
                percentageOfNet
              }
            }
          }
        }
        facilityHasOtherFeesOutsideOfParkingPeriod
      }
    }
`;

export const LIST_MANUAL_INVOICE_BILLING_SETTINGS = gql`
  query listManualInvoiceBillingSettings(
    $facilityId: String!
  ) {
    listManualInvoiceBillingSettings(
          facilityId: $facilityId
      ) {
        id
        profileName
        billingDayInArrears
        dueDayInArrears
        dueDay
        billingDay
      }
  }
`;

export const LIST_FEES_FOR_MANUAL_V2 = gql`
  query listFeesForManual(
    $facilityId: String!
    $parkingPeriod: String!
  ) {
    listFeesForManual(
          facilityId: $facilityId
          parkingPeriod: $parkingPeriod
      ) {
        fees {
          id
          feeName
          calculationType
          feeTypeId
          feeType {
            name
          }
          rateFees {
            rateId
          }
          feesHistory {
            id
            price
            tax1
            tax2
            tax3
            tax4
            startDate
            inactiveDate
            inputType
            taxCalculation
            productCode {
              id
              name
              code
            }
            rateCode {
              id
              name
              code
              description
            }
            taxTableTax1 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax2 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax3 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax4 {
              taxTableRates {
                percentageOfNet
              }
            }
          }
        }
        facilityHasOtherFeesOutsideOfParkingPeriod
      }
    }
`;

export const LIST_FEES_FOR_OTHER_MANUAL_INVOICES_V2 = gql`
  query listFeesForOtherManualInvoices(
    $facilityId: String!
    $feeTypeId: Int!
    $parkingPeriod: String!
  ) {
    listFeesForOtherManualInvoices(
          facilityId: $facilityId
          feeTypeId: $feeTypeId
          parkingPeriod: $parkingPeriod
      ) {
        fees {
          id
          feeName
          calculationType
          feeTypeId
          feeType {
              name
          }
          feesHistory {
            id
            price
            tax1
            tax2
            tax3
            tax4
            inputType
            taxCalculation
            startDate
            inactiveDate
            productCode {
              id
              name
              code
            }
            rateCode {
              id
              name
              code
              description
            }
            taxTableTax1 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax2 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax3 {
              taxTableRates {
                percentageOfNet
              }
            }
            taxTableTax4 {
              taxTableRates {
                percentageOfNet
              }
            }
          }
        }
        facilityHasOtherFeesOutsideOfParkingPeriod
    }
  }
`;

export const GET_FEE_V2 = gql`
    query getFee(
      $feeId: String!
    ) {
      getFee(
        feeId: $feeId
        ) {
            id
            feeName
            calculationType
            feeType {
              name
            }
            facility {
              facilityNumber
              facilityName
              timezone
              id
              organizationId
              cityId
            }
            feeAccessDeviceType {
              accessDeviceType {
                type
                id
              }
            }
            feesHistory {
              id
              startDate
              inactiveDate
              tax1
              tax2
              tax3
              tax4
              inputType
              rateCode {
                id
                name
                code
              }
              taxTableTax1 {
                id
                name
                taxNumber
                taxTableRates {
                  effectiveDate
                  percentageOfNet
                  createdAt
                }
              }
              taxTableTax2 {
                id
                name
                taxNumber
                taxTableRates {
                  effectiveDate
                  percentageOfNet
                  createdAt
                }
              }
              taxTableTax3 {
                id
                name
                taxNumber
                taxTableRates {
                  effectiveDate
                  percentageOfNet
                  createdAt
                }
              }
              taxTableTax4 {
                id
                name
                taxNumber
                taxTableRates {
                  effectiveDate
                  percentageOfNet
                  createdAt
                }
              }
              productCode {
                id
                name
                code
              }
              price
              taxCalculation
            }
        }
    }
`;

export const LIST_FEES_FOR_BILLING_PROFILES_V2 = gql`
    query listFeesForBillingProfiles(
      $facilityId: String!
    ) {
      listFeesForBillingProfiles(
            facilityId: $facilityId
        ) {
            id
            feeName
            calculationType
            feeTypeId
            feeType {
                name
            }
        }
    }
`;

export const LIST_BILLING_PROFILE_NAMES_V2 = gql`
    query listBillingProfileNames(
      $facilityId: String!
      $excludeValidationOnly: Boolean
    ) {
      listBillingProfileNames(
          facilityId: $facilityId
          excludeValidationOnly: $excludeValidationOnly
        ) {
            id
            name
            paymentDueDay
        }
    }`;

export const LIST_RATES_FROM_VIEW_V2_COUNT = gql`
query listRatesFromViewCount(
    $filters: [Filter]
) {
    listRatesFromViewCount(
        filters: $filters
    ) {
        total
    }
}
`;

export const LIST_RATES_FROM_VIEW_V2 = gql`
query listRatesFromView(
  $limit: Int
  $offset: Int
  $order: SortOrder
  $filters: [Filter]
) {
  listRatesFromView(
        limit: $limit
        offset: $offset
        order: $order
        filters: $filters
    ) {
          data {
            active
            rateId
            rateName
            facilityName
            facilityNumber
            facilityTimezone
            monthlyActiveDate
            inactiveDate
            displayOnline
            passType
            accessHours
            location
            sublotName
            firstMonthProration
            firstMonthProrationDay
            billingProfileName
            requireCarInfo
            monthsInAdvance
            accessDeviceMessage
            accessLevelCode
            onlineStartDate
            onlineEndDate
            monthlyFeeName
            activationFeeName
            accessDevice1FeeName
            accessDevice2FeeName
            accessDevice3FeeName
            accessDevice4FeeName
            accessDeviceType1
            accessDeviceType2
            accessDeviceType3
            accessDeviceType4
            parentRateId
            parentRateName
            childDiscountType
            childDiscountAmount
            lateFeeDay
            integration
          }
    }
}
`;

export const GET_DEFAULT_RATE_TAXES = gql`
query getDefaultRateTaxes(
  $rateId: String!
  $facilityId: String!
) {
  getDefaultRateTaxes(
        rateId: $rateId
        facilityId: $facilityId
    ) {
        defaultRateTax1 {
          id
          name
        }
        defaultRateTax2 {
          id
          name
        }
        defaultRateTax3 {
          id
          name
        }
        defaultRateTax4 {
          id
          name
        }
        rateCode {
          id
          name
        }
        productCode {
          id
          name
        }
    }
}
`;

export const LIST_TAX_TABLE_TAXES_V2 = gql`
query listTaxTableTaxes(
  $facilityId: String!
) {
  listTaxTableTaxes(
        facilityId: $facilityId
    ) {
       id
       name
       taxNumber
    }
}
`;

export const LIST_DEFAULT_RATES_FROM_VIEW_V2 = gql`
query listDefaultRatesFromView(
  $limit: Int
  $offset: Int
  $order: SortOrder
  $filters: [Filter]
) {
  listDefaultRatesFromView(
        limit: $limit
        offset: $offset
        order: $order
        filters: $filters
    ) {
          data {
            active
            rateId
            rateName
            facilityName
            facilityNumber
            facilityTimezone
            inactiveDate
            displayOnline
            passType
            accessHours
            location
            sublotName
            firstMonthProration
            firstMonthProrationDay
            billingProfileName
            defaultRateTax1Name
            defaultRateTax2Name
            defaultRateTax3Name
            defaultRateTax4Name
            requireCarInfo
            monthsInAdvance
            accessDeviceMessage
            accessLevelCode
            onlineStartDate
            onlineEndDate
            activationFeeName
            accessDevice1FeeName
            accessDevice2FeeName
            accessDevice3FeeName
            accessDevice4FeeName
            accessDeviceType1
            accessDeviceType2
            accessDeviceType3
            accessDeviceType4
            lateFeeDay
          }
          total
    }
}
`;

export const LIST_CHILD_RATE_METADATA = gql`
query listChildRateMetadata(
  $tenantSubscriptionId: String
) {
  listChildRateMetadata(tenantSubscriptionId: $tenantSubscriptionId) {
        rateId
        discountType
        discountAmount
    }
}
`;

export const GET_RATE_BY_ID_V2 = gql`
query getRateDetailsById(
  $rateId: ID!
) {
  getRateDetailsById(rateId: $rateId) {
    id
    description
    name
    active
    display
    passType
    accessHours
    location
    firstMonthProration
    firstMonthProrationDay
    parentRateId
    taxExempt
    billingProfileId
    requireCarInfo
    createdAt
    updatedAt
    deletedAt
    monthsToSellInAdvance
    accessDeviceMessage
    accessLevelCode
    onlineStartDate
    onlineEndDate
    lateFeeDay
    isSoldOut
    sublot {
      id
      name
    }
    childRateMetadata {
      startDate
      endDate
      discountType
      discountAmount
    }
    billingProfile {
      name
      paymentDueDay
      facility {
        id
        organizationId
        facilityName
        facilityNumber
        timezone
        onlineStartDate
        onlineEndDate
        facilitySettings {
          usesDefaultRates
        }
      }
    }
    rateFees {
      feeId
      rateId
      fee {
        feesHistory {
          productCode {
            code
          }
          rateCode {
            code
          }
        }
        feeName
        feeTypeId
        feeType {
          name
        }
      }
    }
    rateAccessDevices {
      feeId
      rateId
      required
      fee {
        feeName
        feeTypeId
        feeType {
          name
        }
        feesHistory {
          productCode {
            code
          }
          rateCode {
            code
          }
        }
      }
      accessDeviceTypeId
      accessDeviceType {
        type
      }
    }
    salesLimits {
      month
      year
      limit
    }
    promoCodes {
      text
      useLimit
      expiresOn
    }
    externalApiRates {
      integration
    }
    futureChildRateDiscounts {
      id
      rateId
      discountType
      discountAmount
      endDate
      startDate
    }
  }
}
`;

export const GET_FEE_TYPE_ID = gql`
    query getFeeTypeId(
      $feeType: String!
    ) {
      getFeeTypeId(
        feeType: $feeType
      ) {
        id
      }
    }
`;

export const GET_PRODUCT_CODES = gql`
    query getProductCodesByOrganizationId(
      $organizationId: Int!
    ) {
      getProductCodesByOrganizationId(
        organizationId: $organizationId
      ) {
        id
        name
      }
    }
`;

export const GET_RATE_CODES = gql`
    query getRateCodesByOrganizationId(
      $organizationId: Int!
    ) {
      getRateCodesByOrganizationId(
        organizationId: $organizationId
      ) {
        id
        name
      }
    }
`;

export const GET_TAX_TABLE_TAXES_BY_CITY_ID_V2 = gql`
    query getTaxRatesByCityId($cityId: ID!) {
      getTaxRatesByCityId(cityId: $cityId) {
            id
            name
            taxNumber
            taxTableRates {
              percentageOfNet
              effectiveDate
            }
        }
    }
`;

export const GET_CARRYOVER_FEE_TYPES = gql`
query getCarryoverFeeTypes {
   getCarryoverFeeTypes {
        id
        name
    }
}
`;

export const MY_PROFILE = gql`
  query myProfile(
      $cognitoSub: String!
  ) {
      myProfile(
        cognitoSub: $cognitoSub
      ) {
         gpi_cards
         gpi_bank_accounts
      }
    }
`;

export const GET_FEE_TYPES_BY_FACILITY = gql`
query getFeeTypesByFacility($facilityId: String!) {
    getFeeTypesByFacility(facilityId: $facilityId) {
        name
    }
}
`;

export const GET_USERS = gql`
query getUsers(
  $limit: Int,
  $offset: Int,
  $order: SortOrder,
  $filters: [Filter],
) {
    getUsers(
      limit: $limit,
      offset: $offset,
      order: $order,
      filters: $filters,
    ) {
        users {
          id
          firstName
          lastName
          email
          facilities {
            id
          }
          subscriptions {
            id
            subscriptionName
            accountId
          }
          role {
            id
            name
            displayName
          }
        }
        total
    }
}
`;

export const GET_USER = gql`
query getUser(
  $id: String!,
) {
    getUser(
      id: $id,
    ) {
        id
        firstName
        lastName
        email
        facilities {
          id
          name
        }
        role {
          id
          name
          organizationId
          isAssignedFacilities
        }
    }
}
`;

export const LIST_ORGANIZATIONS = gql`
query listOrganizations {
    listOrganizations
     {
      id
      organizationId
      name
    }
}
`;

export const GET_DASHBOARD_ACCESS_CONFIG = gql`
query getDashboardAccessConfig {
    getDashboardAccessConfig
}
`;

export const GET_GITBOOK_JWT = gql`
  query getGitbookJWT {
    getGitbookJWT {
      token
    }
  }
`;

export const LIST_ORGANIZATIONS_BY_ID = gql`
query listOrganizationsById(
  $organizationId: Int!,
) {
    listOrganizationsById(
      organizationId: $organizationId,
    ) {
      id
      name
      code
      FacilityBranches {
        id
        name
        code
        FacilityDistricts {
          id
          name
          code
          facilities {
            id
            facilityName
            facilityNumber
          }
        }
      }
    }
}
`;

export const LIST_ORGANIZATIONS_BY_USER_ID = gql`
query listOrganizationsByUserId(
  $userId: String!,
) {
    listOrganizationsByUserId(
      userId: $userId,
    ) {
      FacilityAreas
      FacilityBranches
      FacilityDistricts
      facilities
    }
}
`;

export const GET_ORGANIZATION_ROLES = gql`
  query getOrganizationRoles($organizationId: Int) {
    getOrganizationRoles(organizationId: $organizationId) {
      id
      name
      displayName
      isAssignedFacilities
    }
  }
`;

export const GET_PAYMENT_APPLICATION_MONTHS = gql`
 query getPaymentApplicationMonths($facility_id: String!) {
        getPaymentApplicationMonths(facility_id: $facility_id) {
            id,
            month,
            year,
            status
        }
    }
`;

export const GET_FACILITY_PAYMENT_TYPES = gql`
  query getFacilityPaymentTypes($facilityId: String!) {
        getFacilityPaymentTypes(facilityId: $facilityId) {
            paymentTypes {
                paymentTypeName
            }
        }
    }`;
export const SEARCH_BY_SUB_NAME_PAYMENT_APP = gql`
  query searchBySubNamePaymentApp($searchTerm: String!) {
    searchBySubNamePaymentApp(searchTerm: $searchTerm) {
      id
      subscriptionName
      accountId
      billingProfile {
        facility {
          facilityName
          facilityNumber
          id
        }
      }
    } 
  }
`;

export const GET_RATES_BY_SUBSCRIPTION = gql`
    query getRatesBySubscription(
        $subscriptionId: String!,
    ) {
        getRatesBySubscription(
            subscriptionId: $subscriptionId,
        ) {
            id
            name
            active
            activeDate
            childRateStartDate
            childRateEndDate
            parentRateId
            tenantRateSublotSelections {
              id
              sublot {
                id
                name
                primaryLot
              }
            }
            tenantSubscriptionRates {
                id
                rateId
                subscriptionId
                isEnabled
            }
            isSoldOut
        }
    }
`;
